export enum OrganisationLoadingStatusEnum {
    Not_started = 0, // Loading user organisations have not been started
    Successful = 1, // User organisations have been successfully loaded
    Failed = -1, // Loading user organisations failed
}